__turbopack_context__.v({
  "description": "ForgotPassword-module-scss-module__qZn3pq__description",
  "form": "ForgotPassword-module-scss-module__qZn3pq__form",
  "form__field": "ForgotPassword-module-scss-module__qZn3pq__form__field",
  "instructions": "ForgotPassword-module-scss-module__qZn3pq__instructions",
  "support": "ForgotPassword-module-scss-module__qZn3pq__support",
});
